import { apiRequest } from "../util/apiUtils";

export const userList = async (params) => {
  try {
    const res = await apiRequest("get", `user/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const userAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `user/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const userDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `user/delete-all`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const userStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `user/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
